// /bonos/success — landing tras pago Stripe exitoso. La creación real del
// bono ocurre en el webhook backend (idempotente), así que esta página solo
// muestra confirmación optimista + redirect a /mis-bonos.

import { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const REDIRECT_MS = 4000;

export default function BonoCompraSuccess() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id') || '';

  useEffect(() => {
    const id = setTimeout(() => navigate('/mis-bonos', { replace: true }), REDIRECT_MS);
    return () => clearTimeout(id);
  }, [navigate]);

  return (
    <main className="bono-result-page">
      <div className="bono-result bono-result--ok">
        <div className="bono-result-icono"><Check size={36} strokeWidth={2} /></div>
        <h1 className="bono-result-titulo">{t('bono_result.success_titulo')}</h1>
        <p className="bono-result-texto">{t('bono_result.success_texto')}</p>
        {sessionId && <p className="bono-result-ref">Ref: {sessionId.slice(-12)}</p>}
        <p className="bono-result-redirect">{t('bono_result.redirect_aviso')}</p>
        <Link to="/mis-bonos" className="btn-primary bono-result-cta">
          {t('bono_result.btn_mis_bonos')}
        </Link>
      </div>
    </main>
  );
}
